import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { useDisplayPrices } from './useDisplayPrices';
import { isPreSuggestionsHidden, PRE_SUGGESTIONS_FALLBACK_QUERY, usePreSuggestionsQuery } from './usePreSuggestionsQuery';
import { useMatchingLabels } from './useMatchingLabels';
import { useResultsPageOfferingsBi } from './useResultsPageOfferingsBi';
export const usePreSuggestions = function (fallbackQuery) {
  if (fallbackQuery === void 0) {
    fallbackQuery = PRE_SUGGESTIONS_FALLBACK_QUERY;
  }
  const _usePreSuggestionsQue = usePreSuggestionsQuery(fallbackQuery),
    data = _usePreSuggestionsQue.data,
    isLoading = _usePreSuggestionsQue.isLoading,
    error = _usePreSuggestionsQue.error;
  const baseRecommendations = (data == null ? void 0 : data.recommendations) ?? [];
  const _useDisplayPrices = useDisplayPrices([baseRecommendations]),
    pricesByDomain = _useDisplayPrices.pricesByDomain,
    isPricingLoading = _useDisplayPrices.isLoading;
  const recommendations = baseRecommendations.map(recommendation => recommendation.domain && pricesByDomain.has(recommendation.domain) ? {
    ...recommendation,
    price: pricesByDomain.get(recommendation.domain)
  } : recommendation);
  useResultsPageOfferingsBi({
    recommendations: baseRecommendations,
    isLoading
  });
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.SDK.useSuggestionActionResolver(),
    resolveActionForSuggestion = _DomainSearchSuiteMod.resolveActionForSuggestion;
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useGetPurchasePermissions({}),
    purchasePermissions = _DomainsApiClient$hoo.data;
  const _useMatchingLabels = useMatchingLabels(recommendations),
    matchLabels = _useMatchingLabels.labels,
    isLoadingLabels = _useMatchingLabels.isLoading;
  const onGetItClick = async recommendation => {
    const position = recommendations.findIndex(_ref => {
      let id = _ref.id;
      return id === recommendation.id;
    });
    DomainSearchSuiteModule.internals.bi.onGetItClick == null || DomainSearchSuiteModule.internals.bi.onGetItClick({
      domain: recommendation.domain || '',
      type: recommendation.label,
      position
    });
    if (recommendation.domain) {
      await resolveActionForSuggestion(recommendation.domain);
    }
  };
  return {
    recommendations,
    isLoading,
    isPricingLoading,
    matchLabels,
    isLoadingLabels,
    disabled: !(purchasePermissions != null && purchasePermissions.hasPermission),
    hidden: isPreSuggestionsHidden({
      error,
      isLoading,
      recommendations: baseRecommendations
    }),
    onGetItClick
  };
};
//# sourceMappingURL=usePreSuggestions.js.map